import { render, staticRenderFns } from "./InvitationListing.vue?vue&type=template&id=4b8d579e&scoped=true&lang=pug&"
import script from "./InvitationListing.vue?vue&type=script&lang=js&"
export * from "./InvitationListing.vue?vue&type=script&lang=js&"
import style0 from "./InvitationListing.vue?vue&type=style&index=0&id=4b8d579e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8d579e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSkeletonLoader,VSpacer})
